import React, { useMemo } from 'react'

import WidgetHeader from '../earnings-common/WidgetHeader'
import { EarningReportReaction } from '../earnings-common/types'
import PriceReactionTable from './PriceReactionTable'
import { EarningsRevisionsByType } from './types'
import { usePriceReactionColumns } from './usePriceReactionColumns'
import { mapPriceReactionData } from './utils'

interface Props {
  priceReactionData: EarningReportReaction[]
  revisionData: EarningsRevisionsByType
}

export default function PriceReaction({ priceReactionData }: Props) {
  const { columns, subColumns } = usePriceReactionColumns(true)

  const data = useMemo(() => mapPriceReactionData(priceReactionData), [priceReactionData])

  return (
    <div className="js-financials-widget">
      <div className="mb-0.5 space-y-1.5">
        <WidgetHeader label="Price Reaction to Earnings Reports" />
      </div>
      <PriceReactionTable columns={columns} data={data} subColumns={subColumns} />
    </div>
  )
}
